import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "edit-individual-business" }
const _hoisted_2 = { class: "edit-individual-business__header__filter-pagination" }
const _hoisted_3 = { key: 0 }

import { storeToRefs } from 'pinia';
import EditIndividualBusinessModal from '../components/EditIndividualBusinessModal.vue';
import { useEditIndividualBusinessStore } from '../pages/useEditIndividualBusinessStore';
import NewBaseTableContent from '@/corePagesModule/BaseTableContent/NewBaseTableContent.vue';
import FilterModalButton from '@/corePagesModule/filterModal/FilterModalButton.vue';
import { i18n } from '@/i18n';
import { editIndividualBusinessChildContentHeader } from '../constants';
import { isLoading } from '@/coreDomainsModule/uiLoadingState';
import Pagination from '@/corePagesModule/components/Pagination.vue';
import { computed, onMounted } from 'vue';
import InfoModal from '@/corePagesModule/components/InfoModal.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'EditIndividualBusiness',
  setup(__props) {

const t = i18n.t;

const store = useEditIndividualBusinessStore();
const { state } = storeToRefs(store);

onMounted(async () => {
  state.value.isBaseBusinessView = false;
  await store.initialization();
});

const getChildBusinessModalDescription = computed(() => {
  const allAvailableNumber = state.value.tableInfo.childBusiness.pagingState.totalResultsAvailable ?? 0;
  const text1 = allAvailableNumber > 50 ? t('該当する取引の先頭50件のみ表示しています。') : '';
  const text2 = t('ここから出荷している取引', { amount: allAvailableNumber ? allAvailableNumber.toString() : '全' });
  return [text1, text2];
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(FilterModalButton, {
        "filter-modal-type": "editIndividualBusiness",
        "select-input-index": 50,
        "filter-items": _unref(store).getFilterItemsValue().value,
        onApply: _cache[0] || (_cache[0] = (filteredContent) => _unref(store).onAppliedFilterModal(filteredContent))
      }, null, 8, ["filter-items"]),
      _createVNode(Pagination, {
        "paging-options": _unref(state).tableInfo.pagingState,
        "is-loading": _unref(isLoading)(_unref(state).tableInfo.loadingState.status),
        onOnChangePage: _cache[1] || (_cache[1] = ($event: any) => (_unref(store).onChangePaging($event)))
      }, null, 8, ["paging-options", "is-loading"])
    ]),
    (_openBlock(), _createBlock(NewBaseTableContent, {
      key: _unref(state).renderingKey,
      "prop-table-content-properties": _unref(state).tableInfo.tableContentProperties,
      "prop-display-objects": _unref(state).tableInfo.tableContentItems,
      "prop-loading-status": _unref(state).tableInfo.loadingState,
      "prop-table-type": 'editIndividualBusiness',
      onOnClickSort: _cache[2] || (_cache[2] = (sortKey, isAsc) => _unref(store).sortTableContentItems(sortKey, isAsc))
    }, null, 8, ["prop-table-content-properties", "prop-display-objects", "prop-loading-status"])),
    _createVNode(EditIndividualBusinessModal),
    _createVNode(InfoModal, {
      "modal-state": _unref(state).modalState.isOpening.childBusinessList,
      "modal-width": 1300,
      "back-button-label": _unref(t)('キャンセル'),
      "next-button-label": _unref(t)('適用'),
      onOnBack: _cache[3] || (_cache[3] = 
        () => {
          _unref(state).modalState.isOpening.childBusinessList = false;
          if (!_unref(state).modalState.isOpening.loading) _unref(state).modalState.isOpening.edit = true;
        }
      ),
      onOnNext: _cache[4] || (_cache[4] = 
        () => {
          _unref(state).modalState.isOpening.loading = true;
          _unref(state).modalState.isOpening.childBusinessList = false;
          _unref(store).putEditedAggregateBusiness();
        }
      )
    }, {
      title: _withCtx(() => [
        _createTextVNode(_toDisplayString(_unref(t)('編集')), 1)
      ]),
      description: _withCtx(() => [
        (_unref(state).tableInfo.childBusiness.loadingState.status.type === 'success')
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createTextVNode(_toDisplayString(getChildBusinessModalDescription.value[0]) + " ", 1),
              (getChildBusinessModalDescription.value[0])
                ? (_openBlock(), _createElementBlock("br", _hoisted_3))
                : _createCommentVNode("", true),
              _createTextVNode(_toDisplayString(getChildBusinessModalDescription.value[1]), 1)
            ], 64))
          : _createCommentVNode("", true)
      ]),
      default: _withCtx(() => [
        _createVNode(NewBaseTableContent, {
          "prop-table-content-properties": _unref(editIndividualBusinessChildContentHeader),
          "prop-display-objects": _unref(state).tableInfo.childBusiness.tableContentItems,
          "prop-loading-status": _unref(state).tableInfo.childBusiness.loadingState,
          "prop-table-type": "editIndividualBusinessChildBusiness",
          class: "edit-individual-business__child-business-modal__table"
        }, null, 8, ["prop-table-content-properties", "prop-display-objects", "prop-loading-status"])
      ]),
      _: 1
    }, 8, ["modal-state", "back-button-label", "next-button-label"]),
    _createVNode(InfoModal, {
      "modal-state": _unref(state).modalState.isOpening.loading,
      icon: "loading",
      "enable-outside-click": false
    }, {
      title: _withCtx(() => [
        _createTextVNode(_toDisplayString(_unref(t)('編集中です・・・')), 1)
      ]),
      _: 1
    }, 8, ["modal-state"]),
    _createVNode(InfoModal, {
      "modal-state": _unref(state).modalState.isOpening.commonError,
      icon: "error",
      "color-style": "error",
      "back-button-label": _unref(t)('確認'),
      "enable-outside-click": false,
      "is-disabled-next-button": "",
      onOnBack: _cache[5] || (_cache[5] = 
        () => {
          _unref(state).modalState.isOpening.commonError = false;
          _unref(state).modalState.isOpening.edit = true;
        }
      )
    }, {
      title: _withCtx(() => [
        _createTextVNode(_toDisplayString(_unref(t)('エラーが発生しました')), 1)
      ]),
      description: _withCtx(() => [
        _createTextVNode(_toDisplayString(_unref(t)('サーバーエラーが発生しました。')) + " ", 1),
        _cache[8] || (_cache[8] = _createElementVNode("br", null, null, -1)),
        _createTextVNode(_toDisplayString(_unref(t)('時間をおいて再度お試しください。')), 1)
      ]),
      _: 1
    }, 8, ["modal-state", "back-button-label"]),
    _createVNode(InfoModal, {
      "modal-state": _unref(state).modalState.isOpening.duplicationError,
      icon: "error",
      "color-style": "error",
      "back-button-label": _unref(t)('確認'),
      "enable-outside-click": false,
      "is-disabled-next-button": "",
      onOnBack: _cache[6] || (_cache[6] = 
        () => {
          _unref(state).modalState.isOpening.duplicationError = false;
          _unref(state).modalState.isOpening.edit = true;
        }
      )
    }, {
      title: _withCtx(() => [
        _createTextVNode(_toDisplayString(_unref(t)('既存の取引が存在します')), 1)
      ]),
      description: _withCtx(() => [
        _createTextVNode(_toDisplayString(_unref(t)('編集後の取引は既に存在するため、編集ができませんでした。')), 1)
      ]),
      _: 1
    }, 8, ["modal-state", "back-button-label"]),
    _createVNode(InfoModal, {
      "modal-state": _unref(state).modalState.isOpening.success,
      "next-button-label": _unref(t)('確認'),
      "enable-outside-click": false,
      onOnNext: _cache[7] || (_cache[7] = async () => await _unref(store).initialization())
    }, {
      title: _withCtx(() => [
        _createTextVNode(_toDisplayString(_unref(t)('編集完了しました')), 1)
      ]),
      _: 1
    }, 8, ["modal-state", "next-button-label"])
  ]))
}
}

})